export const KEYWORD_SEQUENCE = {
 type: "sequenceDiagram",
 block: [
  "alt",
  "par",
  "and",
  "loop",
  "else",
  "end",
  "rect",
  "opt",
  "alt",
  "rect",
 ],
 keyword: [
  "participant",
  "as",
  "Note",
  "note",
  "right of",
  "left of",
  "over",
  "activate",
  "deactivate",
  "autonumber",
  "title",
  "actor",
  "accDescription",
  "link",
  "links",
 ],
}

export const KEYWORD_CLASS = {
 type: ['classDiagram', 'classDiagram-v2'],
 block: 'class',
 keyword: [
  'link',
  'click',
  'callback',
  'call',
  'href',
  'cssClass',
  'direction',
  'TB',
  'BT',
  'RL',
  'LR',
  'title',
  'accDescription',
  'order',
 ],
}
